import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store, select } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState, selectUtilsState } from 'app/store/app.states';
//Calendar
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, ThemePalette } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatRadioChange } from '@angular/material/radio';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-dialog-new-cfdi',
  templateUrl: './dialog-new-cfdi.component.html',
  styleUrls: ['./dialog-new-cfdi.component.scss'],
  providers: [CoalService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ,
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }
  ]
})
export class DialogNewCfdiComponent implements OnInit {
  formCfdi: FormGroup
  radioActive: number = 1;
  rfcPattern: RegExp = new RegExp('^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]?[A-Z,0-9]?[0-9,A-Z]?$');
  namesPattern: RegExp = new RegExp('^[A-z\sñÑáéíóúÁÉÍÓÚüÜ ]{3,30}$');
  blockSpecial: RegExp = /^[^<>*!¡$%@#_[\]+°¿?=()/\\"',;:{}`~|]/;
  // /^[a-z,0-9,-]{36,36}$/
  // /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  uuidPattern: RegExp = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');

  // edoComprobante: any[] = [
  //   { name: 'Todo', code: -1 },
  //   { name: 'Cancelado', code: 0 },
  //   { name: 'Vigente', code: 1 }
  // ];
  estatusComprobantes: any[] = [];
  tiposComprobantes: any[] = [];
  //Calendar
  today: Date = new Date();
  minDate: Date = new Date(2018, 1, 1);
  minDate2: Date = new Date();
  //color: ThemePalette = "primary" | "accent" | "warn";
  //Redux info
  //empresaState$ = this.store.select(selectUtilsState);
  empresaData: any;
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogNewCfdiComponent>,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private coalService: CoalService,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formCfdi = this.fb.group({
      uuid: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.pattern(this.uuidPattern)]),
      fechaInicial: new FormControl({ value: '', disabled: true }),
      fechaFinal: new FormControl({ value: '', disabled: true }),
      rfcReceptor: new FormControl({ value: '', disabled: true }),
      rfcEmisor: new FormControl({ value: '', disabled: true }),
      rfcSolicitante: new FormControl({ value: '', disabled: true }),
      tipoSolicitud: new FormControl({ value: '', disabled: true }),
      tipoComprobante: new FormControl({ value: 1, disabled: true }),
      estadoComprobante: new FormControl({ value: 2, disabled: true }),
      rfcCuentaTerceros: new FormControl({ value: '', disabled: true }),
      complemento: new FormControl({ value: '', disabled: true }),
    });

  }
  //[Validators.required]
  //[Validators.pattern(this.rfcPattern)]

  async ngOnInit(): Promise<void> {

    this.empresaData = await this.getData();
    console.log("🚀 ~ file: dialog-new-cfdi.component.ts:98 ~ DialogNewCfdiComponent ~ ngOnInit ~ this.empresaData:", this.empresaData)
    
    //Get Estatus Tarea
    this.getEstatusTarea();
    //Get Estatus Comprobante
    this.getEstatusComprobantes();
    //Get Tipo Comprobante
    this.getTipoComprobantes();

  }

  public getData(): Promise<any> {
    return new Promise<any>(resolve => {
      this.store.pipe(select(selectUtilsState)).subscribe((info:any) => {
        let empresa = info?.empresaSeleccionada || null;
        resolve(empresa);
      });

    });

  }
  // convenience getter for easy access to form fields
  get f() { return this.formCfdi.controls; }

  upperCase(ctrl: string, event: any) {
    if (ctrl && event) {
      this.formCfdi.get(ctrl)?.setValue(event.target.value?.toUpperCase());
    }
  }

  lowerCase(ctrl: string, event: any) {
    if (ctrl && event) {
      this.formCfdi.get(ctrl)?.setValue(event.target.value?.toLowerCase());
    }
  }

  dateChange(event: MatDatepickerInputEvent<Date>) {
    console.log(`dateChange: ${event.value}`)
    let min = new Date(event.value);
    this.minDate2 = min;
    this.f['fechaFinal'].setValue(this.minDate2);

  }

  getEstatusTarea() {

    this.coalService.getService('cat-tarea-estatuses?populate=*')
      .subscribe((res: any) => {
        console.log("🚀 ~ file: dialog-new-cfdi.component.ts ~ line 132 ~ getEstatusTarea ~ .subscribe ~ res", res)
      }, (error: any) => {
        console.log("🚀 ~ file: dialog-new-cfdi.component.ts ~ line 134 ~ getEstatusTarea ~ .subscribe ~ error", error)
      })
  }

  getEstatusComprobantes() {
    //fac-estatus.fac-estatus?page=1&pageSize=10&sort=nombre:ASC
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService('fac-estatuses?filters[esTimbrado][$eq]=1')
      .subscribe((res: any) => {
        console.log("🚀 ~ file: dialog-new-cfdi.component.ts:59 ~ getEstatusComprobantes ~ .subscribe ~ res", res)
        this.estatusComprobantes = res.data;
        this.store.dispatch(OcultarSpinner());
      }, (error: any) => {
        this.store.dispatch(OcultarSpinner());
      })
  }

  getTipoComprobantes() {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService('cat-tipo-comprobantes?populate=*')
      .subscribe((res: any) => {
        console.log("🚀 ~ file: dialog-new-cfdi.component.ts:59 ~ getTipoComprobantes ~ .subscribe ~ res", res)
        this.tiposComprobantes = res.data;
        this.store.dispatch(OcultarSpinner());
      }, (error: any) => {
        this.store.dispatch(OcultarSpinner());
      })
  }

  radioChange(data: MatRadioChange) {
    console.log('Selected value:', data.value);
    let opt = Number(data.value) || 1;
    //Es opcion 1
    if (opt == 1) {
      this.f['uuid'].setValidators([Validators.required, Validators.pattern(this.uuidPattern)]);
      this.f['uuid'].setValue('');
      this.f['uuid'].enable();

      this.f['fechaInicial'].setValue(null);
      this.f['fechaInicial'].clearValidators();
      this.f['fechaInicial'].disable();

      this.f['fechaFinal'].setValue(null);
      this.f['fechaFinal'].clearValidators();
      this.f['fechaFinal'].disable();

      this.f['rfcReceptor'].setValue('');
      this.f['rfcReceptor'].clearValidators();
      this.f['rfcReceptor'].disable();

      this.f['rfcEmisor'].setValue('');
      this.f['rfcEmisor'].clearValidators();
      this.f['rfcEmisor'].disable();

      this.f['estadoComprobante'].setValue(null);
      this.f['estadoComprobante'].disable();

      this.f['tipoComprobante'].setValue(null);
      this.f['tipoComprobante'].disable();
    }

    if (opt == 2) {//Es opcion 2
      this.f['uuid'].clearValidators();
      this.f['uuid'].setValue('');
      this.f['uuid'].disable();

      this.f['fechaInicial'].setValue(null);
      this.f['fechaInicial'].setValidators([Validators.required]);
      this.f['fechaInicial'].enable();

      this.f['fechaFinal'].setValue(null);
      this.f['fechaFinal'].setValidators([Validators.required]);
      this.f['fechaFinal'].enable();

      this.f['rfcReceptor'].setValue('');
      this.f['rfcReceptor'].setValidators([Validators.pattern(this.rfcPattern)]);
      this.f['rfcReceptor'].enable();

      this.f['rfcEmisor'].setValue('');
      this.f['rfcEmisor'].setValidators([Validators.pattern(this.rfcPattern)]);
      this.f['rfcEmisor'].enable();

      this.f['estadoComprobante'].setValue(2);
      this.f['estadoComprobante'].enable();

      this.f['tipoComprobante'].setValue(1);
      this.f['tipoComprobante'].enable();
    }

    this.formCfdi.updateValueAndValidity();
  }

  search() {
    //this.formCfdi.markAllAsTouched();

    if (!this.formCfdi.valid) {
      return this._snackBar.open(
        'Favor de completar los datos',
        'OK',
        { duration: 3000 }
      )
    }
    let fechaInit = this.f['fechaInicial'].value;
    let fechaFin = this.f['fechaFinal'].value;
    //Set hours init
    if (this.isNullOrEmpty(fechaInit)) {
      let fInit = new Date(fechaInit);
      fInit.setHours(0, 0, 0);
      fechaInit = fInit;
    }
    //Set hours end
    if (this.isNullOrEmpty(fechaFin)) {
      let fFin = new Date(fechaFin);
      fFin.setHours(23, 59, 59);
      fechaFin = fFin;
    }

    let params = {
      idEmpresa: this.empresaData?.id || null,
      uuid: this.f['uuid'].value || null,
      fechaInicial: fechaInit || null,
      fechaFinal: fechaFin || null,
      rfcReceptor: this.f['rfcReceptor'].value || null,
      rfcEmisor: this.f['rfcEmisor'].value || null,
      rfcSolicitante: this.f['rfcSolicitante'].value || null,
      tipoSolicitud: this.f['tipoSolicitud'].value || null,
      cat_tipo_comprobante: this.f['tipoComprobante'].value || null,
      fac_estatus: this.f['estadoComprobante'].value || null,
      rfcCuentaTerceros: this.f['rfcCuentaTerceros'].value || null,
      complemento: this.f['complemento'].value || null,
      cat_tipo_complemento: null
    }
    console.log("🚀 ~ file: dialog-new-cfdi.component.ts:221 ~ DialogNewCfdiComponent ~ search ~ params:", params)

    this.store.dispatch(MostrarSpinner());

    //Send Data
    this.coalService.postService('tar-recuperacion/search', params)
    .subscribe((res: any) => {
    console.log("🚀 ~ file: dialog-new-cfdi.component.ts:289 ~ DialogNewCfdiComponent ~ .subscribe ~ res:", res)

      this.store.dispatch(OcultarSpinner());
      let re= res?.data?.attributes || null;
      let msj = re?.mensaje || null;
      this._snackBar.open(msj,'OK',{ duration: 9000 });

      this.close(1);     
    }, (error: any) => {
      //let err = error?.error?.message || null;
      console.log("🚀 ~ file: dialog-new-cfdi.component.ts:293 ~ DialogNewCfdiComponent ~ .subscribe ~ error:", error)

      this.store.dispatch(OcultarSpinner());
      this._snackBar.open('Error al procesar solicitud...','ERROR',{ duration: 10000 });
      this.close(0);

    })


  }

  close(status) {
    this.dialogRef.close({
      success: status
    });
  }

  // Validation object
  isNullOrEmpty(obj: any): boolean {
    return obj !== undefined && obj !== null && obj !== '';
  }

}
